<template>
  <div>
    <transition name="fade" mode="out-in" appear>
      <v-snackbar v-model="snackbar" :timeout="-1" :multi-line="true" :right="true" :bottom="true" :vertical="true">
        <span class="body-1">{{ $t('components.common.missingImages') }}</span
        ><br /><br /><span v-html="$t('components.common.contactUsForHelp')"></span>
        <template v-slot:action="{ attrs }">
          <v-btn color="primary" class="black--text" v-bind="attrs" @click="closeSnackbar">
            {{ $t('common.close') }}
          </v-btn>
        </template>
      </v-snackbar>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    show: false,
  },

  data() {
    return {
      snackbar: false,
      keepClosed: false,
    };
  },

  watch: {
    show(val) {
      this.snackbar = false;

      if (val === true && this.keepClosed === false) {
        setTimeout(() => {
          this.snackbar = true;
        }, 3000);
      }
    },
  },

  methods: {
    closeSnackbar() {
      this.snackbar = false;
      this.keepClosed = true;
    },
  },
};
</script>

<style>
.v-snack__action {
  align-self: center !important;
}
</style>
